/* ================================================================
   ARS WINE — Product Page JS
   Handles: gallery, qty, add-to-cart, sticky bar, toast, profile bars
   ================================================================ */
(function () {
  'use strict';

  // ── State ────────────────────────────────────────────────────────
  var state = {
    qty: 1,
    cart: 0,
    unitPrice: parseFloat(document.querySelector('[data-unit-price]')?.dataset.unitPrice || '0'),
  };

  // ── DOM refs ─────────────────────────────────────────────────────
  var qtyValEl      = document.querySelector('[data-qty-val]');
  var qtyDecBtn     = document.querySelector('[data-qty-dec]');
  var qtyIncBtn     = document.querySelector('[data-qty-inc]');
  var totalPriceEls = document.querySelectorAll('[data-total-price]');
  var cartBadgeEls  = document.querySelectorAll('[data-cart-badge]');
  var stickyBar     = document.querySelector('[data-sticky-bar]');
  var toast         = document.querySelector('[data-toast]');
  var galleryMain   = document.querySelector('[data-gallery-main]');
  var galleryThumbs = document.querySelectorAll('[data-gallery-thumb]');
  var addToCartBtns = document.querySelectorAll('[data-add-to-cart]');
  var productForm   = document.getElementById('product-form');

  // ── Helpers ──────────────────────────────────────────────────────
  function fmtPrice(n) {
    return '€ ' + n.toFixed(2).replace('.', ',');
  }

  // ── Render ───────────────────────────────────────────────────────
  function render() {
    if (qtyValEl) qtyValEl.textContent = state.qty;
    if (qtyDecBtn) qtyDecBtn.disabled = state.qty <= 1;

    var total = state.unitPrice * state.qty;
    totalPriceEls.forEach(function (el) { el.textContent = fmtPrice(total); });

    var showBadge = state.cart > 0;
    cartBadgeEls.forEach(function (el) {
      el.textContent = state.cart;
      el.classList.toggle('is-visible', showBadge);
    });
  }

  // ── Quantity ─────────────────────────────────────────────────────
  if (qtyDecBtn) {
    qtyDecBtn.addEventListener('click', function () {
      if (state.qty > 1) { state.qty--; render(); }
    });
  }

  if (qtyIncBtn) {
    qtyIncBtn.addEventListener('click', function () {
      state.qty++;
      render();
    });
  }

  // ── Add to cart ──────────────────────────────────────────────────
  var toastTimeout;

  function showToast() {
    if (!toast) return;
    clearTimeout(toastTimeout);
    var word = state.cart === 1 ? 'bottiglia' : 'bottiglie';
    toast.textContent = '✓ Aggiunto al carrello — ' + state.cart + ' ' + word;
    toast.classList.add('is-visible');
    toastTimeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2400);
  }

  function doAddToCart(e) {
    if (e) e.preventDefault();
    state.cart += state.qty;
    render();
    showToast();

    // Shopify AJAX cart API
    if (productForm && typeof fetch !== 'undefined') {
      var variantInput = productForm.querySelector('[name="id"]');
      var variantId = variantInput ? variantInput.value : null;
      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: state.qty }),
        }).then(function (res) {
          if (res.ok) return res.json();
        }).then(function () {
          // Refresh cart count from Shopify
          return fetch('/cart.js');
        }).then(function (res) {
          if (res && res.ok) return res.json();
        }).then(function (cart) {
          if (cart && typeof cart.item_count === 'number') {
            state.cart = cart.item_count;
            render();
          }
        }).catch(function () {});
      }
    }
  }

  addToCartBtns.forEach(function (btn) {
    btn.addEventListener('click', doAddToCart);
  });

  // ── Gallery ──────────────────────────────────────────────────────
  galleryThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var newSrc = thumb.dataset.mainSrc;
      if (!newSrc || !galleryMain) return;

      // Smooth swap
      galleryMain.style.opacity = '0.5';
      setTimeout(function () {
        galleryMain.src = newSrc;
        galleryMain.onload = function () { galleryMain.style.opacity = '1'; };
        galleryMain.style.opacity = '1';
      }, 80);

      galleryThumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // ── Sticky bar ───────────────────────────────────────────────────
  if (stickyBar) {
    var rafPending = false;
    window.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () {
        rafPending = false;
        stickyBar.classList.toggle('is-visible', window.scrollY > 600);
      });
    }, { passive: true });
  }

  // ── Profile bars — animate on first view ─────────────────────────
  var bars = document.querySelectorAll('[data-meter-fill]');
  if (bars.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var fill = entry.target;
          fill.style.width = fill.dataset.meterFill;
          observer.unobserve(fill);
        }
      });
    }, { threshold: 0.2 });
    bars.forEach(function (b) { observer.observe(b); });
  } else {
    // No IntersectionObserver — set widths immediately
    bars.forEach(function (b) { b.style.width = b.dataset.meterFill; });
  }

  // ── Init ─────────────────────────────────────────────────────────
  render();

})();
